<button (click)="openFoldersModal()"
        class="folder-btn"
        mat-stroked-button
        type="button">
    <mat-icon [svgIcon]="'uipath:switch_folder'"
              class="folder-icon"></mat-icon>
    <div class="text">
        <div *ngLet="currentFolderName$ | async as folderName"
             [matTooltip]="folderName"
             class="folder-name">
            {{ folderName }}
        </div>
        <div *ngLet="currentFolderType$ | async as folderType"
             [matTooltip]="folderType"
             class="folder-type">
            {{ folderType }}
        </div>
    </div>
    <mat-icon>keyboard_arrow_down</mat-icon>
</button>
